import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { BehaviorSubject, Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private isConnected$ = new BehaviorSubject<boolean>(true);
  private isNative = Capacitor.isNativePlatform();

  constructor() {
    if (this.isNative) {
      this.initializeNetworkMonitoring();
    }
  }

  /**
   * Observable que emite el estado de conexión (true = conectado, false = sin conexión)
   */
  get connectionStatus$(): Observable<boolean> {
    return this.isConnected$.asObservable();
  }

  /**
   * Inicializa el monitoreo de red en plataformas nativas
   */
  private async initializeNetworkMonitoring(): Promise<void> {
    try {
      // Obtener estado inicial
      const status = await Network.getStatus();
      this.isConnected$.next(status.connected);

      // Escuchar cambios de red
      Network.addListener('networkStatusChange', (status) => {
        console.log('🌐 Estado de red cambió:', status.connected ? 'Conectado' : 'Sin conexión');
        this.isConnected$.next(status.connected);
      });
    } catch (error) {
      console.error('Error al inicializar monitoreo de red:', error);
    }
  }

  /**
   * Obtiene el estado actual de conexión
   */
  async getCurrentStatus(): Promise<boolean> {
    if (!this.isNative) {
      return true; // En web siempre retornar true
    }

    try {
      const status = await Network.getStatus();
      return status.connected;
    } catch (error) {
      console.error('Error al obtener estado de red:', error);
      return true; // En caso de error, asumir conectado
    }
  }
}
